import { makeAutoObservable } from 'mobx';
import type { ProductPin } from '@/features/layout/types';
import {
  loadSidebarExpanded,
  saveSidebarExpanded,
  loadProductPins,
  saveProductPins,
} from '@/features/layout/logic';

class SidebarStore {
  isExpanded = true;
  pins: ProductPin[] = [];
  activeItem = '';
  mobileOpen = false;

  constructor() {
    makeAutoObservable(this);
    this.isExpanded = loadSidebarExpanded();
    this.pins = loadProductPins();
  }

  toggleCollapse() {
    this.isExpanded = !this.isExpanded;
    saveSidebarExpanded(this.isExpanded);
  }

  setExpanded(expanded: boolean) {
    this.isExpanded = expanded;
    saveSidebarExpanded(this.isExpanded);
  }

  setMobileOpen(open: boolean) {
    this.mobileOpen = open;
  }

  setActiveItem(id: string) {
    this.activeItem = id;
  }

  pinProduct(pin: ProductPin) {
    if (!this.pins.find((p) => p.id === pin.id)) {
      this.pins.push(pin);
      saveProductPins(this.pins);
    }
  }

  unpinProduct(id: string) {
    this.pins = this.pins.filter((p) => p.id !== id);
    saveProductPins(this.pins);
  }

  reorderPins(pins: ProductPin[]) {
    this.pins = pins;
    saveProductPins(this.pins);
  }
}

export const sidebarStore = new SidebarStore();
